import PropTypes from 'prop-types';
import React from 'react';

import { TextButton, SecondaryTextButton } from '@bibliocommons/base-buttons';

import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import UgcLikesModal from './UgcLikesModal';

import './UgcLikesButton.scss';

export default function UgcLikesButton({
  contentId,
  count,
  modalActions,
  likesActions,
  buttonText,
  buttonType = 'secondary'
}) {
  const modalKey = `ugc-likes-modal-${contentId}`;

  const openModal = () => {
    modalActions.openModal(modalKey, { authRequired: false });
  };
  const closeModal = () => modalActions.closeModal(modalKey);

  return buttonType === 'primary' ? (
    <div className="cp-ugc-likes-button">
      <TextButton handleClick={openModal} className="ugc-likes-modal-button" dataKey="ugc-likes-modal-button">
        {buttonText}
      </TextButton>
      <ModalContainer modalKey={modalKey} handleClose={closeModal} size="small">
        <UgcLikesModal contentId={contentId} count={count} likesActions={likesActions} />
      </ModalContainer>
    </div>
  ) : (
    <div className="cp-ugc-likes-button">
      <SecondaryTextButton
        handleClick={openModal}
        className="ugc-likes-modal-button"
        dataKey="ugc-likes-modal-button"
        size="small"
      >
        {buttonText}
      </SecondaryTextButton>
      <ModalContainer modalKey={modalKey} handleClose={closeModal} size="small">
        <UgcLikesModal contentId={contentId} count={count} likesActions={likesActions} />
      </ModalContainer>
    </div>
  );
}

UgcLikesButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  buttonType: PropTypes.oneOf(['primary', 'secondary']),
  contentId: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  likesActions: PropTypes.objectOf(PropTypes.func).isRequired
};
